export default "__VITE_ASSET__CYtsvrfj__"